import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const SlickSlider = ({ settings = {}, children }) => {
  const finalSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    ...settings,
  };


  return (
    <Slider {...finalSettings}>
      {children}
    </Slider>
  );
};

export default SlickSlider;
